export const BASE_URL = 'https://cloud-music-api.clearw1ne.com/';
